import React, { forwardRef } from 'react';
import { Box as MUIBox, BoxProps as MUIBoxProps } from '@mui/material';

export const View = forwardRef(({ ...props }: MUIBoxProps, ref) => {
  return (
    <MUIBox
      ref={ref}
      flexDirection={'column'}
      width={'100%'}
      display={'flex'}
      minHeight={0}
      flex={1}
      {...props}
    >
      {props.children}
    </MUIBox>
  );
});
